import BlankLayout from '../layouts/blanklayout.jsx';
import FullLayout from '../layouts/fulllayout.jsx';
import BillingPage from '../views/pages/BillingPage';

const indexRoutes = [
  { path: '/auth', name: 'Authentication', component: BlankLayout },
  { path: '/account', name: 'Account', component: BlankLayout },
  { path: '/billing', name: 'Billing', component: BillingPage },
  { path: '/', name: 'Dashboard', component: FullLayout, protected: true }
];

export default indexRoutes;
